import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { useParams } from "react-router-dom";

import Register from "./Register";
import { useRedirectAuthenticatedUsers } from "./use-redirect-authenticated-users";

const UNAUTHENTICATED_TEAM_INVITE_QUERY = gql`
  query UnauthenticatedTeamInvite($accessToken: String!) {
    unauthenticatedTeamInvite(accessToken: $accessToken) {
      uuid
      inviteeEmail
      teamName
    }
  }
`;

export default function RegisterTeamInvite() {
  const { accessToken } = useParams();
  const { data } = useQuery(UNAUTHENTICATED_TEAM_INVITE_QUERY, {
    variables: { accessToken },
  });

  useRedirectAuthenticatedUsers();

  return (
    <div>
      <Register
        isTeamInvite={true}
        teamInviteData={data}
        accessToken={accessToken}
      />
    </div>
  );
}
